import { CSSProperties } from 'react';

export const containerStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: 20
};

export const labelStyle: CSSProperties = {
  fontSize: '14px',
  color: '#666'
};

export const buttonGroupStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#f0f0f0',
  borderRadius: '20px',
  padding: '4px'
};

export const buttonStyle: CSSProperties = {
  padding: '8px 16px',
  borderRadius: '16px',
  border: 'none',
  color: 'black',
  fontSize: '14px',
  cursor: 'pointer',
  minWidth: '100px',
  textAlign: 'center'
};

export const activeButtonStyle: CSSProperties = {
  backgroundColor: 'white',
  fontWeight: 'bold'
};

export const inactiveButtonStyle: CSSProperties = {
  backgroundColor: 'transparent',
  fontWeight: 'normal'
};
